import React from "react";

const serviceContent = [
  { icon: "lnil-cup", name: "Brand Consultant" },
  { icon: "lnil-website-rank", name: "UI/UX Solution" },
  { icon: "lnil-3d", name: "Packaging" },
  { icon: "lnil-video-camera-alt-1", name: "Motion Video & TVC" },
];

const ServiceListThree = () => {
  return (
    <>
      <ul>
        {serviceContent.map((val, i) => (
          <li key={i}>
            <span href="#" className="text-white">
              <i className={`lnil ${val.icon} text-white`}></i> {val.name}
            </span>
          </li>
        ))}
      </ul>
    </>
  );
};

export default ServiceListThree;
